import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    "name": 'apcalendareventtype',
    standalone: true
})
export class ApCalendarEventTypePipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 1:
                return 'Cut-Off for Approved & Invoiced POs';
            case 2:
                return 'Payments processed';
            case 3:
                return 'Check Mail Date';
            case 4:
                return 'ACH Payments deposited';
            default:
                return '';
        }
    }
}
